import React, { useRef } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./Benefits.css";
import poolImg from "../../assets/benefit/peoplepool.jpg";
import gymImg from "../../assets/benefit/peopleworkout.jpg";
import restaurantImg from "../../assets/benefit/peopleRestaurant.jpg";
import barImg from "../../assets/benefit/peoplebar.jpg";
import eventImg from "../../assets/benefit/eventcenter.jpg";
import wifiImg from "../../assets/benefit/freewifi.jpg";
import ImageWithFallback from "../common/ImageWithFallback";

const benefits = [
  {
    image: poolImg,
    name: "Swimming Pool",
    text: "Our pool area offers a relaxing escape where guests can unwind, socialize, or simply enjoy a refreshing swim after a busy day. It promotes wellness and adds a luxury touch to your stay.",
  },
  {
    image: gymImg,
    name: "Fitness Center",
    text: "Stay on top of your fitness goals while traveling. Our fully equipped gym ensures you never have to compromise your workout routine, helping you feel energized throughout your trip.",
  },
  {
    image: restaurantImg,
    name: "Restaurant",
    text: "Experience world-class dining without leaving the hotel. Our restaurant serves a curated menu of local and international dishes, giving guests a memorable culinary experience.",
  },
  {
    image: barImg,
    name: "Exclusive Bar",
    text: "Unwind with handcrafted cocktails and premium spirits in a sophisticated setting. Our bar is the perfect spot for evening relaxation or casual conversations.",
  },
  {
    image: eventImg,
    name: "Event Center",
    text: "From business conferences to weddings, our versatile event spaces are designed to host seamless gatherings with professional support and elegant decor.",
  },
  {
    image: wifiImg,
    name: "Free Wi-Fi",
    text: "Stay connected throughout your stay with complimentary high-speed internet. Whether for work or leisure, our reliable Wi-Fi ensures a seamless online experience.",
  },
];

const matchMap = {
  "Swimming Pool": ["pool", "swimming"],
  "Fitness Center": ["gym", "fitness", "workout"],
  "Restaurant": ["restaurant", "dining", "food"],
  "Exclusive Bar": ["bar", "lounge", "cocktail"],
  "Event Center": ["event", "conference", "banquet", "hall", "wedding"],
  "Free Wi-Fi": ["wifi", "wi-fi", "internet", "free wifi"],
};

const Benefits = ({ amenities }) => {
  const trackRef = useRef(null);

  const scroll = (dir) => {
    if (!trackRef.current) return;
    const card = trackRef.current.querySelector(".benefits__card");
    const cardWidth = card.offsetWidth + 24;
    trackRef.current.scrollBy({ left: dir === "next" ? cardWidth : -cardWidth, behavior: "smooth" });
  };

  const filteredBenefits = amenities && amenities.length > 0
    ? benefits.filter((item) => {
        const keywords = matchMap[item.name] || [item.name.toLowerCase()];
        return amenities.some((a) => {
          const name = (typeof a === "string" ? a : a.amenity || a.name || "").toLowerCase();
          return keywords.some((kw) => name.includes(kw));
        });
      })
    : benefits;

  if (filteredBenefits.length === 0) return null;

  return (
    <section className="benefits">
      <button className="benefits__nav benefits__nav--prev" onClick={() => scroll("prev")}>
        <FaChevronLeft />
      </button>
      <div className="benefits__track" ref={trackRef}>
        {filteredBenefits.map((item) => (
          <div className="benefits__card" key={item.name}>
            <ImageWithFallback src={item.image} alt={item.name} className="benefits__card-img" />
            <div className="benefits__card-overlay" />
            <h3 className="benefits__card-name">{item.name}</h3>
            <p className="benefits__card-text">{item.text}</p>
          </div>
        ))}
      </div>
      <button className="benefits__nav benefits__nav--next" onClick={() => scroll("next")}>
        <FaChevronRight />
      </button>
    </section>
  );
};

export default Benefits;
